import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { ShiftTimelineUnassignedRegionState } from '@wilson/shift-timeline/state';

@Pipe({
  name: 'getServiceName',
  standalone: true,
})
export class GetServiceNamePipe implements PipeTransform {
  private store = inject(Store);

  transform(id: string) {
    return this.store.select(
      ShiftTimelineUnassignedRegionState.getServiceName(id),
    );
  }
}
